(function () {
  function iniciarSlider(slider) {
    if (!slider || slider.dataset.zbReady === 'true') return;

    var imagemDepois = slider.querySelector('.zb-after');
    var divisor = slider.querySelector('.zb-baslider-handle');

    if (!imagemDepois || !divisor) return;

    var arrastando = false;
    var posicaoAtual = 50;

    function atualizarPosicao(valor) {
      posicaoAtual = Math.max(0, Math.min(100, valor));

      imagemDepois.style.clipPath =
        'inset(0 0 0 ' + posicaoAtual + '%)';

      imagemDepois.style.webkitClipPath =
        'inset(0 0 0 ' + posicaoAtual + '%)';

      divisor.style.left = posicaoAtual + '%';

      slider.setAttribute(
        'aria-valuenow',
        Math.round(posicaoAtual)
      );
    }

    function calcularPosicao(evento) {
      var area = slider.getBoundingClientRect();
      var porcentagem =
        ((evento.clientX - area.left) / area.width) * 100;

      atualizarPosicao(porcentagem);
    }

    slider.addEventListener('pointerdown', function (evento) {
      arrastando = true;

      if (slider.setPointerCapture) {
        slider.setPointerCapture(evento.pointerId);
      }

      calcularPosicao(evento);
      evento.preventDefault();
    });

    slider.addEventListener('pointermove', function (evento) {
      if (!arrastando) return;

      calcularPosicao(evento);
      evento.preventDefault();
    });

    slider.addEventListener('pointerup', function () {
      arrastando = false;
    });

    slider.addEventListener('pointercancel', function () {
      arrastando = false;
    });

    slider.addEventListener('lostpointercapture', function () {
      arrastando = false;
    });

    slider.addEventListener('keydown', function (evento) {
      if (evento.key === 'ArrowLeft') {
        atualizarPosicao(posicaoAtual - 5);
        evento.preventDefault();
      }

      if (evento.key === 'ArrowRight') {
        atualizarPosicao(posicaoAtual + 5);
        evento.preventDefault();
      }
    });

    slider.dataset.zbReady = 'true';
    atualizarPosicao(50);
  }

  function procurarSliders(area) {
    var local = area || document;

    local
      .querySelectorAll('.zb-baslider')
      .forEach(iniciarSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      procurarSliders(document);
    });
  } else {
    procurarSliders(document);
  }

  document.addEventListener('shopify:section:load', function (evento) {
    procurarSliders(evento.target);
  });
})();